import React, {useState, useEffect} from 'react';
import './style/MyInfoCard.css';
import { FaRegIdCard, FaBook, FaBrain  } from 'react-icons/fa';
import { BsPersonSquare  } from 'react-icons/bs';


function MyInfoCard({option, handleOption}){

    const [text, setText] = useState('');

    useEffect(() => {
            switch (option) {
                case 'Personal':
                    setText(`Hi, I am <span>Daniel Garcia</span> I'm a system engineering also full stack web developer, I can provide clean code and pixel perfect design. I also make website more & more interactive with web.
                            <br>
                            <br>
                            Full Name: Daniel Antonio Garcia Arias
                            <br>
                            Age: 24
                            <br>
                            Adress: mz d casa 84 villa marbella
                            <br>
                            Phone: +57 3006674009`);
                    break;
                case 'Education':
                    setText(`<p></p>
                             <ul>
                                <li><strong>Present</strong>-Systems engineering, Universidad del magdalena</li>
                                <li><strong>2020</strong>-React Hooks: Guia inicial utilizando Redux y Material.UI(Udemy),Juan Jose Ortiz del Toro</li>
                                <li><strong>2019</strong>-Escuela de JavaScript(Platzi)</li>
                                <li><strong>2018</strong>-Curso de React.js(Platzi)</li>
                                <li><strong>2018</strong>-Curso de Desarrollo web - Responsive Design(Platzi)</li>
                                <li><strong>2017</strong>-Curso profesional de Git y GitHub 2017(Platzi)</li>
                                <li><strong>2014</strong>-High school, Ciudadela Educativa Cooedumag</li>
                             </ul>`);
                    break;
                case 'Profile':
                    setText('I am a person with capacities and values, among which the responsibility, respect, honesty, dynamism and perseverance that allow me to carry out the activities assigned to me in a timely and organized manner stood out. I focus on developing applications in a web environment. Competent to analyze, design, build and implement systems according to customer needs, applying good quality practices in the software development process.');
            
                    break;
                case 'Thought':
                    setText('I like to create and innovate but sometimes these things require thinking outside the box and it is one of the things that characterizes me.');
        
                    break;
                default:
                    break;
            }
    });

    return (
        <div className="information" >
            <div className="info_decoration_img">
                <div className="icon_container">
                    <div className="icon_aboutme icon_impar" onClick={() => handleOption("Personal")}><FaRegIdCard/></div>
                    <div className="icon_aboutme icon_par" onClick={() => handleOption("Education")}><FaBook/></div>
                    <div className="icon_aboutme icon_impar" onClick={() => handleOption("Profile")}><BsPersonSquare/></div>
                    <div className="icon_aboutme icon_par" onClick={() => handleOption("Thought")}><FaBrain/></div>
                </div>
            </div>
            <div className="txt_information">
                <h3>{option}</h3>
                <p dangerouslySetInnerHTML={{__html: text}} ></p>
            </div>
        </div>
    );
}

export default MyInfoCard;
